import { render, staticRenderFns } from "./TargetedCities.vue?vue&type=template&id=2781c98e&scoped=true&"
import script from "./TargetedCities.vue?vue&type=script&lang=js&"
export * from "./TargetedCities.vue?vue&type=script&lang=js&"
import style0 from "./TargetedCities.vue?vue&type=style&index=0&id=2781c98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781c98e",
  null
  
)

export default component.exports